import { Flex, Link } from '@chakra-ui/react';
import React, { useEffect, useRef, useState } from 'react';
import DoencaService from "../../../main/services/DoencaService";
import Tabela from '../../components/Tabela';
import { Link as ReactLink } from "react-router-dom";
import { isEmptyArray } from "formik";
import Loading from "../../components/Loading";
import { useAuthProvider } from '../../../Context/AuthProvider';


const ListaDoenca = () => {

    document.title = 'MCA - Doenças'


    const _IsMounted = useRef(false);
    const { roleKeycloack } = useAuthProvider();
    const [columns] = useState([
        {
            Header: 'Descrição',
            accessor: 'descricao',
            Cell: (props => {

                const id = props.row.original.id;
                var descricao = props.value;

                if (descricao.length > 100) {
                    descricao = descricao.substring(0, 100) + "..."
                }
                return <Link title={props.value} as={ReactLink} to={"/doenca/" + id}>{descricao}</Link>
            })
        },
        {
            Header: 'Data Início',
            accessor: 'dataInicio',
            Cell: (props) => {
                const custom_date = new Date(props.value).toLocaleDateString("pt-BR")
                return <span>{custom_date}</span>
            }
        },
        {
            Header: 'Data de término',
            accessor: 'dataFim',
            Cell: (props) => {
                if (props.value) {
                    const custom_date = new Date(props.value).toLocaleDateString("pt-BR")
                    return <span>{custom_date}</span>
                }
                return <span></span>

            }
        },
    ])
    const [data, setData] = useState([]);
    const [fixedData, setFixedData] = useState([]);
    const [filter] = useState('');
    const [loading, setLoading] = useState(true);
    const [nullData, setNullData] = useState(true)

    useEffect(() => {
        setLoading(true)
        _IsMounted.current = true;
        fetchData();

        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function getDoenca() {
        return DoencaService.listarDoenca();

    }

    function fetchData(state) {
        setLoading(true)
        getDoenca()
            .then(res => {
                if (!isEmptyArray(res.data)) {
                    setNullData(false)
                }
                setData(res.data)
                setFixedData(res.data)
                setLoading(false)

            }).catch((error) => {
                console.warn(error)
            })
    }


    return (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >

            <Flex
                w="100%"
            >
            </Flex>

            {loading ? (
                <Loading />
            ) : (
                <Flex>
                    <Tabela
                        data={data}
                        loading={loading}
                        columns={columns}
                        setLoading={setLoading}
                        filter={filter}
                        setData={setData}
                        dataNull={nullData}
                        fixedData={fixedData}
                        placeholderFilter="Pesquise pela Doença"
                        entidade="doenca"
                        roleKeycloack={roleKeycloack}
                    />
                </Flex>
            )}
        </Flex>
    )
}

export default ListaDoenca;